import React, { PropTypes } from 'react';
import { Link } from 'react-router'
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import SharedTools from '../../lib/SharedTools';
import { Select, InputNumber, Modal, message } from 'antd';

const Option = Select.Option;


export default class ArchiveContentSettingIndexPage extends React.Component {

  constructor(props) {
    super(props);
    // set state

    let currentSemester = SharedTools.getCurrentSemester();
    // let semesters = SharedTools.getAllSemesters(currentSemester, 20171);
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      grades: [],
      graduatedArray: [],
      showGraduated: false,
      schoolId: this.props.params.schoolId,

      currentSemester,
      semester: currentSemester,
      semesters: [],

      graduatedArray: [],

      // 添加页数
      modalVisible: false,
      count: 1
    };
    // bind this
    this.onCurrentRoleChange = this.onCurrentRoleChange.bind(this);
    this.toolGraduatedDate = this.toolGraduatedDate.bind(this);
  }

  componentWillMount() {
    // let data = {
    //   school_id: this.state.schoolId,
    //   info: 'template',
    //   semester: this.state.semester
    // }
    // this.loadClasses(data)

    DataService.getSchoolInfo(this.state.schoolId).then((school) => {
      let currentSemester = this.state.currentSemester
      if (school && school.archive_semester_count == 1) {
        let year = this.state.currentSemester.toString().split('').slice(0, 4).join('');
        currentSemester = Number(year + '1');
      }
      let semesters = SharedTools.getAllSemesters(currentSemester, 20171, school.archive_semester_count)

      this.setState({
        semester: currentSemester,
        semesters,
        currentSemester
      })

      let data = {
        school_id: this.state.schoolId,
        info: 'template',
        semester: currentSemester
      }
      this.loadClasses(data)

    }).catch((error) => {
      console.log(error);
    });
  }

  loadClasses(data) {
    DataService.getClassList(data).then(res => {
      let grades = [], graduatedArray = [];
      res.map(classItem => {
        if (this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system' || this.state.currentRole.associatName == 'classGrade' && !classItem.is_deleted) {
          let index = grades.findIndex((grade) => grade.id == classItem.class_grade_id);
          if (index >= 0) {
            grades[index].classes.push(classItem);
          } else {
            grades.push({
              id: classItem.class_grade_id,
              name: classItem.grade_name,
              classes: [classItem],
              is_graduated: classItem.is_graduated,
              graduate_date: classItem.graduate_date
            })
          }
        }
        if (this.state.currentRole.associatName == 'classGrade') {
          grades = grades.filter((grade) => grade.id == this.state.currentRole.associatObj.id);
        }
      })
      this.setState({
        grades: grades.filter((grade) => !grade.is_graduated),
        graduatedArray: grades.filter((grade) => grade.is_graduated)
      })
    });

  }

  componentDidMount(){
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }

  onCurrentRoleChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole()
    });
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        let data = {
          school_id: this.state.schoolId,
          info: 'template',
          semester: value
        }
        this.loadClasses(data);
      })
    }
  }

  addPageCount(gradeId) {
    let grade = this.state.grades.find(grade => grade.id == gradeId);
    if (grade) {
      let archive_ids = grade.classes.map(c => c.archive_id);
      this.setState({
        modalVisible: true,
        archive_ids
      })
    }
  }

  cancelModalVisible() {
    this.setState({
      modalVisible: false,
      count: 1
    });
  }

  addPageCountApi() {
    let data = {
      archive_ids: this.state.archive_ids,
      count: this.state.count
    }
    DataService.addPageCount(data).then((res) => {
      this.cancelModalVisible()
      message.success('添加成功');
    }).catch((error) => {
      message.error('添加页数失败');
    })
  }

  onChangePageCount(value) {
    this.setState({
      count: value
    })
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  _addPageCountView() {
    return (
      <Modal
        title="添加档案页数"
        visible={this.state.modalVisible}
        onOk={() => this.addPageCountApi()}
        onCancel={() => this.cancelModalVisible()}
        className="add-page-count-modal"
      >
        <label>请输入需要为该年级段添加的档案页数</label>
        <InputNumber  min={1}
                      value={this.state.count}
                      placeholder="输入添加页数"
                      onChange={this.onChangePageCount.bind(this)}
                      style={{marginLeft: '20px'}}
        />
      </Modal>
    )
  }

  render() {
    return (
      <div className="archive-content-setting-index-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        {this._addPageCountView()}
        <div className="grades-list">
          {this.state.grades.map(grade => {
            return <div className="grade-box" key={"grade-" + grade.id}>
              <div className="grade-name">
                {grade.name}
                {this.state.currentRole.associatName == 'system' || this.state.currentRole.associatName == 'school' ? <a className="add-label" onClick={this.addPageCount.bind(this, grade.id)}>增加档案页数</a> : ''}
              </div>
              {grade.classes.map((classItem, classIndex) => {
                return <div className="class-box" key={"class-" + classItem.id}>
                  <Link to={`archive/content-setting/schools/${this.props.params.schoolId}/classes/${classItem.id}?semester=${this.state.semester}`}>
                    <div className="class-content">
                      <div className="text-bg">{classItem.name}</div>
                      <div className="text-sm">已选{classItem.pages_count || 0}个模版</div>
                    </div>
                  </Link>
                </div>
              })}
            </div>
          })}
          <div style={{ color: '#4DA1FF', marginBottom: '20px', cursor: 'pointer' }} onClick={() => this.setState({ showGraduated: !this.state.showGraduated })}>{this.state.showGraduated ? '收起' : '查看'}毕业班级</div>
          {this.state.showGraduated && this.state.graduatedArray.map(grade => {
            return <div className="grade-box" key={"grade-" + grade.id}>
              <div className="grade-name">{grade.name} - {this.toolGraduatedDate(grade.graduate_date)}毕业</div>
              {grade.classes.map((classItem, classIndex) => {
                return <div className="class-box" key={"class-" + classItem.id}>
                  <Link to={`archive/content-setting/schools/${this.props.params.schoolId}/classes/${classItem.id}?semester=${this.state.semester}`}>
                    <div className="class-content">
                      <div className="text-bg">{classItem.name}</div>
                      <div className="text-sm">已选{classItem.pages_count || 0}个模版</div>
                    </div>
                  </Link>
                </div>
              })}
            </div>
          })}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveContentSettingIndexPage.jsx